import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

// Accueil : messages automatiques en attente de confirmation (rien ne part sans Ralph).
export function OutboxAlert() {
  const [n, setN] = useState(0);
  const navigate = useNavigate();
  useEffect(() => { api.get("/outbox/count").then((r) => setN(r.data.pending || 0)).catch(() => {}); }, []);
  if (!n) return null;
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-6 rounded-xl border border-violet-500/50 bg-violet-500/[0.08] p-4 flex items-center justify-between gap-3" data-testid="outbox-alert">
      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-violet-300 font-semibold">Messages à approuver</p>
        <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="outbox-alert-title">{n} courriel{n > 1 ? "s" : ""}/SMS préparé{n > 1 ? "s" : ""} attendent ta confirmation</h3>
        <p className="text-xs text-zinc-400">Rappels carte qui expire, SMS présents non payés, invitations carte — rien ne part sans toi.</p>
      </div>
      <button onClick={() => navigate("/app/membres-paiements?tab=approuver")} className="shrink-0 px-3 py-1.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-xs font-semibold" data-testid="outbox-alert-open">Lire et confirmer →</button>
    </div>
  );
}
